module.exports = __webpack_public_path__ + "img/1482221865.da52376f.jpg";